import { render } from "./EmptyContactField.vue?vue&type=template&id=c8f2d2f8"
import script from "./EmptyContactField.vue?vue&type=script&lang=js"
export * from "./EmptyContactField.vue?vue&type=script&lang=js"
script.render = render

export default script